// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contact-us {
  max-width: 100%; /* Full width for mobile */
  margin: 20px auto;
  padding: 15px;
  border-radius: 8px;
}
.contact-us form {
  display: flex;
  flex-direction: column;
}
.contact-us form .form-group {
  margin-bottom: 15px;
}
.contact-us form .form-group label {
  display: block;
  font-size: 14px;
  margin-bottom: 5px;
  color: #555;
}
.contact-us form .form-group input,
.contact-us form .form-group textarea {
  width: 100%;
  padding: 10px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
}
.contact-us form .form-group input:focus,
.contact-us form .form-group textarea:focus {
  border-color: var(--pmu-primary);
  outline: none;
}
.contact-us form .form-group textarea {
  resize: vertical;
  min-height: 100px;
}
.contact-us form button {
  padding: 10px;
  font-size: 16px;
  color: #fff;
  background: var(--pmu-primary);
  border: none;
  border-radius: 4px;
  cursor: pointer;
  width: 100%;
  transition: background 0.3s ease;
}
.contact-us form button:hover {
  background: var(--pmu-primary-dark);
}
.contact-us form button:disabled {
  background: #ddd;
  cursor: not-allowed;
}
.contact-us .response-message {
  margin-top: 15px;
  font-size: 14px;
  color: #007bff;
  text-align: center;
}

/* Responsive styles for tablets and larger screens */
@media (min-width: 768px) {
  .contact-us {
    max-width: 600px;
    margin: 50px auto;
    padding: 20px;
  }
  .contact-us form .form-group label {
    font-size: 16px;
  }
  .contact-us form .form-group input,
  .contact-us form .form-group textarea {
    padding: 12px;
    font-size: 16px;
  }
  .contact-us form button {
    font-size: 18px;
    padding: 12px;
  }
  .contact-us .response-message {
    font-size: 16px;
  }
}
@media (min-width: 1024px) {
  .contact-us {
    max-width: 800px;
  }
  .contact-us form .form-group input,
  .contact-us form .form-group textarea {
    font-size: 18px;
  }
  .contact-us form button {
    font-size: 18px;
    padding: 14px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/contact-us/contactUs.scss"],"names":[],"mappings":"AAAA;EACE,eAAA,EAAA,0BAAA;EACA,iBAAA;EACA,aAAA;EACA,kBAAA;AACF;AACE;EACE,aAAA;EACA,sBAAA;AACJ;AACI;EACE,mBAAA;AACN;AACM;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,WAAA;AACR;AAEM;;EAEE,WAAA;EACA,aAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,sBAAA;AAAR;AAEQ;;EACE,gCAAA;EACA,aAAA;AACV;AAGM;EACE,gBAAA;EACA,iBAAA;AADR;AAKI;EACE,aAAA;EACA,eAAA;EACA,WAAA;EACA,8BAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,WAAA;EACA,gCAAA;AAHN;AAKM;EACE,mCAAA;AAHR;AAMM;EACE,gBAAA;EACA,mBAAA;AAJR;AASE;EACE,gBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;AAPJ;;AAWA,qDAAA;AACA;EACE;IACE,gBAAA;IACA,iBAAA;IACA,aAAA;EARF;EAYM;IACE,eAAA;EAVR;EAaM;;IAEE,aAAA;IACA,eAAA;EAXR;EAeI;IACE,eAAA;IACA,aAAA;EAbN;EAiBE;IACE,eAAA;EAfJ;AACF;AAmBA;EACE;IACE,gBAAA;EAjBF;EAqBM;;IAEE,eAAA;EAnBR;EAuBI;IACE,eAAA;IACA,aAAA;EArBN;AACF","sourcesContent":[".contact-us {\n  max-width: 100%; /* Full width for mobile */\n  margin: 20px auto;\n  padding: 15px;\n  border-radius: 8px;\n\n  form {\n    display: flex;\n    flex-direction: column;\n\n    .form-group {\n      margin-bottom: 15px;\n\n      label {\n        display: block;\n        font-size: 14px;\n        margin-bottom: 5px;\n        color: #555;\n      }\n\n      input,\n      textarea {\n        width: 100%;\n        padding: 10px;\n        font-size: 14px;\n        border: 1px solid #ccc;\n        border-radius: 4px;\n        box-sizing: border-box;\n\n        &:focus {\n          border-color: var(--pmu-primary);\n          outline: none;\n        }\n      }\n\n      textarea {\n        resize: vertical;\n        min-height: 100px;\n      }\n    }\n\n    button {\n      padding: 10px;\n      font-size: 16px;\n      color: #fff;\n      background: var(--pmu-primary);\n      border: none;\n      border-radius: 4px;\n      cursor: pointer;\n      width: 100%;\n      transition: background 0.3s ease;\n\n      &:hover {\n        background: var(--pmu-primary-dark);\n      }\n\n      &:disabled {\n        background: #ddd;\n        cursor: not-allowed;\n      }\n    }\n  }\n\n  .response-message {\n    margin-top: 15px;\n    font-size: 14px;\n    color: #007bff;\n    text-align: center;\n  }\n}\n\n/* Responsive styles for tablets and larger screens */\n@media (min-width: 768px) {\n  .contact-us {\n    max-width: 600px;\n    margin: 50px auto;\n    padding: 20px;\n\n    form {\n      .form-group {\n        label {\n          font-size: 16px;\n        }\n\n        input,\n        textarea {\n          padding: 12px;\n          font-size: 16px;\n        }\n      }\n\n      button {\n        font-size: 18px;\n        padding: 12px;\n      }\n    }\n\n    .response-message {\n      font-size: 16px;\n    }\n  }\n}\n\n@media (min-width: 1024px) {\n  .contact-us {\n    max-width: 800px;\n\n    form {\n      .form-group {\n        input,\n        textarea {\n          font-size: 18px;\n        }\n      }\n\n      button {\n        font-size: 18px;\n        padding: 14px;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
